import React, { Component } from 'react';
import { Link } from 'react-router-dom'

import { StyleSheet, css } from 'aphrodite';

import { Color, ColorEnvironment, Font, Flexbox } from './Styles';

const styles = StyleSheet.create({
  buttonContainer: {
    height: 50,
    marginTop: 10,
    width: '100%',
    backgroundColor: Color.primaryInverse,
    borderRadius: '0px 0px 10px 10px'
  },
  button: {
    borderTop: `3px solid ${Color.primary}`,
    textDecoration: 'none',
    cursor: 'pointer',
    borderLeft: `3px solid ${Color.primary}`,
    ':first-child': {
      borderLeft: 'none'
    }
  }
});

class ButtonSet extends Component {
  render() {
    return(
      <div className={css(styles.buttonContainer, Flexbox.row, Flexbox.axisFill, Flexbox.crossFill)}>
        {this.props.buttons.map(button => {
          return this.renderButton(button);
        })}
      </div>
    );
  }

  renderButton(button) {
    if (typeof(button[1]) === 'function') {
      return(
        <div className={css(styles.button, Flexbox.column, Flexbox.axisCenter, Flexbox.crossCenter, Flexbox.fillVertical, Flexbox.grow)} onClick={button[1]} key={button[0]}>
          <div className={css(Font.heading, ColorEnvironment.normal)}>{button[0]}</div>
        </div>
      );
    } else if (typeof(button[1]) === 'string') {
      return(
        <Link to={button[1]} className={css(styles.button, Flexbox.column, Flexbox.axisCenter, Flexbox.crossCenter, Flexbox.fillVertical, Flexbox.grow)} key={button[0]}>
          <div className={css(Font.heading, ColorEnvironment.normal)}>{button[0]}</div>
        </Link>
      );
    }
  }
}

export default ButtonSet;



// WEBPACK FOOTER //
// ./src/ButtonSet.js